import { interpolate, getProperties as templateGetProperties } from './svgFiltersTemplates';
import { filterPresets } from './svgPresets';
function getFilter(id, name, overrides, attrs) {
    var filter = filterPresets[name] || [];
    return interpolate(id, filter, overrides || {}, attrs);
}
function getShadow(id, shadow) {
    return interpolate(id, [{ key: 'shadow', value: shadow }], {});
}
function getProperties(name, overrides) {
    var filter = filterPresets[name] || [];
    return templateGetProperties(filter, overrides || {});
}
function isFilterExists(effectName) {
    return effectName in filterPresets;
}
export { getFilter, getShadow, getProperties, isFilterExists };
//# sourceMappingURL=svgFilters.js.map